import {
  Control,
  FieldErrors,
  FormState,
  UseFormGetValues,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch,
} from 'react-hook-form';
import { PolicyFormValues } from './policy-dialog';
import AddEmailDelegateAction from './policy-actions/add-email-delegate';
import AddShareDriveAction from './policy-actions/add-share-drive';
import ChangeImapAction from './policy-actions/change-imap';
import ChangeContactSharingAction from './policy-actions/change-contact-sharing';
import ReassignAliasesAction from './policy-actions/reassign-alliases';
import AddSendAsAction from './policy-actions/add-send-as';
import AddToGroupAction from './policy-actions/add-to-group';
import ApplySignatureTemplateAction from './policy-actions/apply-signature-template';
import ChangeCpanelRoleAction from './policy-actions/change-cPanel-role';
import ChangeGpanelRoleAction from './policy-actions/change-gPanel-role';
import ChangePopAction from './policy-actions/change-pop';
import CreateGmailLabelAction from './policy-actions/create-gmail-label';
import DuplicateUserGroupsAction from './policy-actions/duplicate-user-groups';
import LastLoginAction from './policy-actions/last-login';
import RemoveDomainFindableSharesAction from './policy-actions/remove-domain-findable-shares';
import RemoveFromGroupAction from './policy-actions/remove-from-group';
import RemoveSpecificSharesAction from './policy-actions/remove-specific-shares';
import SetForwardingAction from './policy-actions/set-forwarding';
import SetOrganizationAction from './policy-actions/set-organization';
import SuspendInactiveUsersAction from './policy-actions/suspend-inactive-users';
import SuspendUserAction from './policy-actions/suspend-user';
import UpdateMobileDeviceAction from './policy-actions/update-mobile-devices';
import RemoveEmailDelegateAction from './policy-actions/remove-email-delegate';
import DynamicGroupAssignment from './policy-actions/dynamic-group-assignment';
import SetProfileInfoStep from './set-profile-info-step';
import StepThree from './step-three';

interface PolicyActionProps {
  control: Control<PolicyFormValues>;
  setValue: UseFormSetValue<PolicyFormValues>;
  watch: UseFormWatch<PolicyFormValues>;
  errors: FieldErrors<PolicyFormValues>;
  trigger: UseFormTrigger<PolicyFormValues>;
  actionType: string;
  actionDisplayValue: string;
  actionTypeDescription: string;
  domains: string[];
  gPanelRoles: string[];
  formState: FormState<PolicyFormValues>;
  getValues: UseFormGetValues<PolicyFormValues>;
  directoryRoles: string[];
}

export default function PolicyAction({
  setValue,
  watch,
  control,
  errors,
  actionType,
  actionDisplayValue,
  trigger,
  domains,
  gPanelRoles,
  formState,
  getValues,
  directoryRoles,
}: PolicyActionProps) {
  return (
    <>
      {actionDisplayValue === 'Add Delegate To Account' ? (
        <AddEmailDelegateAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
          domains={domains}
          trigger={trigger}
        />
      ) : actionDisplayValue === 'Add To Shared Drive' ? (
        <AddShareDriveAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
          trigger={trigger}
        />
      ) : actionDisplayValue === 'Apply Signature Template' ? (
        <ApplySignatureTemplateAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
        />
      ) : actionDisplayValue === 'Change IMAP' ? (
        <ChangeImapAction key={actionType} setValue={setValue} watch={watch} />
      ) : actionDisplayValue === 'Change Contact Sharing' ? (
        <ChangeContactSharingAction
          key={actionType}
          setValue={setValue}
          watch={watch}
        />
      ) : actionDisplayValue === 'Reassign Aliases' ? (
        <ReassignAliasesAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
        />
      ) : actionDisplayValue === 'Set Forwarding' ? (
        <SetForwardingAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
        />
      ) : actionDisplayValue === 'Set Organization' ? (
        <SetOrganizationAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
        />
      ) : actionDisplayValue === 'Suspend User' ? (
        <SuspendUserAction key={actionType} setValue={setValue} watch={watch} />
      ) : actionDisplayValue === 'Suspend Inactive Users' ? (
        <SuspendInactiveUsersAction
          setValue={setValue}
          key={actionType}
          control={control}
          errors={errors}
          watch={watch}
        />
      ) : actionDisplayValue === 'Change cPanel Role' ? (
        <ChangeCpanelRoleAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
        />
      ) : actionDisplayValue === 'Change POP' ? (
        <ChangePopAction key={actionType} setValue={setValue} watch={watch} />
      ) : actionDisplayValue === 'Duplicate User Groups' ? (
        <DuplicateUserGroupsAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
        />
      ) : actionDisplayValue === 'Create Gmail Label' ? (
        <CreateGmailLabelAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
          trigger={trigger}
        />
      ) : actionDisplayValue === 'Remove Delegate From Account' ? (
        <RemoveEmailDelegateAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
          domains={domains}
          trigger={trigger}
        />
      ) : actionDisplayValue === 'Remove Domain Findable Shares' ? (
        <RemoveDomainFindableSharesAction
          key={actionType}
          control={control}
          watch={watch}
          errors={errors}
        />
      ) : actionDisplayValue === 'Remove Specific Shares' ? (
        <RemoveSpecificSharesAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
          trigger={trigger}
        />
      ) : actionDisplayValue === 'Add Send As' ? (
        <AddSendAsAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
          trigger={trigger}
        />
      ) : actionDisplayValue === 'Remove From Group' ? (
        <RemoveFromGroupAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
          trigger={trigger}
        />
      ) : actionDisplayValue === 'Update Mobile Devices' ? (
        <UpdateMobileDeviceAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
        />
      ) : actionDisplayValue === 'Change gPanel Role' ? (
        <ChangeGpanelRoleAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
          gPanelRoles={gPanelRoles}
        />
      ) : actionDisplayValue === 'Add To Group' ? (
        <AddToGroupAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
          trigger={trigger}
        />
      ) : actionDisplayValue === 'Last Login Action' ? (
        <LastLoginAction
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
        />
      ) : actionDisplayValue === 'Dynamic Group Assignment' ? (
        <DynamicGroupAssignment
          key={actionType}
          control={control}
          errors={errors}
          setValue={setValue}
          watch={watch}
          trigger={trigger}
        />
      ) : actionDisplayValue === 'Set Profile Information' ? (
        <SetProfileInfoStep
          key={actionType}
          control={control}
          watch={watch}
          setValue={setValue}
          getValues={getValues}
          directoryRoles={directoryRoles}
          formState={formState}
        />
      ) : actionDisplayValue === 'Create Gmail Filter' ? (
        <StepThree
          key={actionType}
          control={control}
          watch={watch}
          setValue={setValue}
          getValues={getValues}
          errors={errors}
          trigger={trigger}
        />
      ) : null}
    </>
  );
}
